import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {SummaryBar} from "@/components/summaryBar/SummaryBar.tsx";
import {SummaryBlock} from "@/components/summaryBar/SummaryBar.types.ts";
import {dateOnly} from "@/lib/format.tsx";

interface SubscriptionSummaryStats {
  trialExpiresAt: string;
}

export const SubscriptionSummaryFreeTrial = () => {
  const {user} = useCurrentUserContext();
  const stats: SubscriptionSummaryStats = {
    trialExpiresAt: user!.account.free_trial_expires_at,
  };
  const summaryBlocks: SummaryBlock<SubscriptionSummaryStats>[] = [
    {
      title: "Current Plan",
      renderStat: () => <>Free Trial</>,
    },
    {
      title: "Trial expires on",
      renderStat: ({trialExpiresAt}) => (
        <>{dateOnly(trialExpiresAt, user!.current_date_format, user!.account!.timezone)}</>
      ),
    },
  ];
  return (
    <SummaryBar
      stats={stats}
      summaryBlocks={summaryBlocks}
      columns={{
        sm: 1,
        md: 2,
        lg: 2,
        xl: 2,
      }}
    />
  );
};
